import apiClient, {
  setAccessToken,
  setRefreshToken,
  getRefreshToken,
} from "@/api/client";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  email: string;
  password: string;
  plan?: string;
  // PDF-11: server requires this to be literally true. The signup form
  // sends true after the user ticks the ToS+Privacy checkbox; the server
  // records the canonical accepted_at timestamp.
  termsAccepted: true;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    plan: string;
    billingCycle: string;
    createdAt: string;
    emailVerifiedAt: string | null;
  };
}

export async function login(data: LoginRequest): Promise<AuthResponse> {
  const response = await apiClient.post<AuthResponse>("/auth/login", data);
  setAccessToken(response.data.accessToken);
  setRefreshToken(response.data.refreshToken);
  return response.data;
}

export async function register(data: RegisterRequest): Promise<AuthResponse> {
  const response = await apiClient.post<AuthResponse>("/auth/register", data);
  setAccessToken(response.data.accessToken);
  setRefreshToken(response.data.refreshToken);
  return response.data;
}

export async function logout(): Promise<void> {
  try {
    await apiClient.post("/auth/logout");
  } finally {
    setAccessToken(null);
    setRefreshToken(null);
  }
}

export async function refreshToken(): Promise<AuthResponse> {
  const rt = getRefreshToken();
  if (!rt) throw new Error("No refresh token");
  const response = await apiClient.post<AuthResponse>("/auth/refresh", {
    refreshToken: rt,
  });
  setAccessToken(response.data.accessToken);
  if (response.data.refreshToken) setRefreshToken(response.data.refreshToken);
  return response.data;
}

export async function resendVerification(): Promise<void> {
  await apiClient.post("/auth/resend-verification");
}
